import { render, staticRenderFns } from "./officebodyContent.vue?vue&type=template&id=993cd2be&scoped=true&"
import script from "./officebodyContent.vue?vue&type=script&lang=js&"
export * from "./officebodyContent.vue?vue&type=script&lang=js&"
import style0 from "./officebodyContent.vue?vue&type=style&index=0&id=993cd2be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993cd2be",
  null
  
)

export default component.exports